import {
  initializeFaro,
  getWebInstrumentations,
  ReactIntegration,
  ReactRouterVersion,
  LogLevel,
  type Faro,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router';
import { env } from '@/shared/api';
import { scrubFaroItem } from './scrub';

let faro: Faro | undefined;

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export function isTelemetryEnabled(): boolean {
  return env.telemetryEnabled && !env.useMock && !env.e2eMode && Boolean(env.faroUrl);
}

export function getFaro(): Faro | undefined {
  return faro;
}

export function initFaro(): Faro | undefined {
  if (faro) return faro;
  if (!isTelemetryEnabled() || !env.faroUrl) return undefined;

  faro = initializeFaro({
    url: env.faroUrl,
    app: { name: 'shanti-frontend', version: env.appVersion, environment: env.appEnv },
    consoleInstrumentation: {
      disabledLevels: [LogLevel.LOG, LogLevel.DEBUG, LogLevel.INFO, LogLevel.TRACE],
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),
      new TracingInstrumentation({
        instrumentationOptions: {
          propagateTraceHeaderCorsUrls: [new RegExp(escapeRegExp(env.apiBaseUrl))],
        },
      }),
      new ReactIntegration({
        router: {
          version: ReactRouterVersion.V7,
          dependencies: {
            createRoutesFromChildren,
            matchRoutes,
            Routes,
            useLocation,
            useNavigationType,
          },
        },
      }),
    ],
    beforeSend: scrubFaroItem,
  });

  return faro;
}
